// Context-Kern getrennt vom Provider (react-refresh), analog KeyboardContextCore.

import { createContext, useContext } from 'react';
import type { ScannerContextValue } from './types';

export const ScannerContext = createContext<ScannerContextValue | undefined>(undefined);

export const useScanner = (): ScannerContextValue => {
  const ctx = useContext(ScannerContext);
  if (!ctx) {
    throw new Error('useScanner must be used within a ScannerProvider');
  }
  return ctx;
};
